import React from 'react'
import ReturnBackBtn from '../../atom/ReturnBackBtn/ReturnBackBtn'
import styles from './HeaderWidget.module.scss'

export interface HeaderWidgetProps {
    children?: React.ReactNode
    withBackBtn?: boolean
    handleBackBtn?: () => void
    labelBackBtn?: string
    variant?: "dark" | "light"
}

export default function HeaderWidget({children ,variant, handleBackBtn, labelBackBtn='Retourner'}: HeaderWidgetProps) {


  return (
    <div style={{color : (variant === 'dark' ? 'white' : '')} } className={[styles['header'], styles['header--'+variant]].join(" ")}>
        { handleBackBtn &&
            <ReturnBackBtn onClick={handleBackBtn} variant={variant === 'dark' ? 'dark' : undefined} size='small' label={labelBackBtn}/>
        }
        <h2 className={[styles['header__title'], styles['header__title--'+variant]].join(" ")}>{children}</h2>
    </div>
  )
}
